import Home from "@/views/Home";
import Login from "@/views/Login";
import FirstLogin from "@/views/FirstLogin";
import User from "@/views/User";
import UserNew from "@/views/UserNew";
import UserDetail from "@/views/UserDetail";
import UserEdit from "@/views/UserEdit";
import DepartmentHistory from "@/views/DepartmentHistory";
import DepartmentHistoryNew from "@/views/DepartmentHistoryNew";
import DepartmentHistoryForceEdit from "@/views/DepartmentHistoryForceEdit";
import PositionHistory from "@/views/PositionHistory";
import PositionHistoryNew from "@/views/PositionHistoryNew";
import PositionHistoryForceEdit from "@/views/PositionHistoryForceEdit";
import RankHistory from "@/views/RankHistory";
import RankHistoryNew from "@/views/RankHistoryNew";
import RankHistoryEdit from "@/views/RankHistoryEdit";
import AccidentHistory from "@/views/AccidentHistory";
import AccidentHistoryNew from "@/views/AccidentHistoryNew";
import AccidentHistoryEdit from "@/views/AccidentHistoryEdit";
import CompanyNotice from "@/views/CompanyNotice";
import CompanyNoticeNew from "@/views/CompanyNoticeNew";
import CompanyNoticeEdit from "@/views/CompanyNoticeEdit";
import Master from "@/views/Master";
import MasterCompany from "@/views/MasterCompany";
import MasterDepartment from "@/views/MasterDepartment";
import MasterDepartmentNew from "@/views/MasterDepartmentNew";
import MasterDepartmentEdit from "@/views/MasterDepartmentEdit";
import MasterPosition from "@/views/MasterPosition";
import MasterPositionNew from "@/views/MasterPositionNew";
import MasterPositionEdit from "@/views/MasterPositionEdit";
import MasterSite from "@/views/MasterSite";
import MasterSiteDetail from "@/views/MasterSiteDetail";
import MasterSiteEdit from "@/views/MasterSiteEdit";
import MasterCar from "@/views/MasterCar";
import MasterCarNew from "@/views/MasterCarNew";
import MasterCarEdit from "@/views/MasterCarEdit";
import MasterPhrase from "@/views/MasterPhrase";
import MasterPhraseNew from "@/views/MasterPhraseNew";
import MasterPhraseEdit from "@/views/MasterPhraseEdit";
import MasterHoliday from "@/views/MasterHoliday";
import MasterHolidayNew from "@/views/MasterHolidayNew";
import MasterHolidayEdit from "@/views/MasterHolidayEdit";
import MasterApproval from "@/views/MasterApproval";
import MasterApprovalDetail from "@/views/MasterApprovalDetail";
import MasterApprovalEdit from "@/views/MasterApprovalEdit";
import Attendance from "@/views/Attendance";
import AttendanceUserDetail from "@/views/AttendanceUserDetail";
import AttendanceDateDetail from "@/views/AttendanceDateDetail";
import AttendanceDateApproval from "@/views/AttendanceDateApproval";
import Approval from "@/views/Approval";
import Notice from "@/views/Notice";
import Csv from "@/views/Csv";
import CsvAttendance from "@/views/CsvAttendance";
import CsvSite from "@/views/CsvSite";
import CsvCost from "@/views/CsvCost";
import CsvTkc from "@/views/CsvTkc";

export default {
  data: [
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: { noAuth: true }
    },
    {
      path: "/first_login",
      name: "first_login",
      component: FirstLogin
    },
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/user",
      name: "user",
      component: User
    },
    {
      path: "/user/new",
      name: "user_new",
      component: UserNew
    },
    {
      path: "/user/:user_id",
      name: "user_detail",
      component: UserDetail
    },
    {
      path: "/user/:user_id/edit",
      name: "user_edit",
      component: UserEdit
    },
    {
      path: "/department_history/:user_id",
      name: "department_history",
      component: DepartmentHistory
    },
    {
      path: "/department_history/:user_id/new",
      name: "department_history_new",
      component: DepartmentHistoryNew
    },
    {
      path: "/department_history/:user_id/force_edit",
      name: "department_history_force_edit",
      component: DepartmentHistoryForceEdit
    },
    {
      path: "/position_history/:user_id",
      name: "position_history",
      component: PositionHistory
    },
    {
      path: "/position_history/:user_id/new",
      name: "position_history_new",
      component: PositionHistoryNew
    },
    {
      path: "/position_history/:user_id/force_edit",
      name: "position_history_force_edit",
      component: PositionHistoryForceEdit
    },
    {
      path: "/rank_history/:user_id",
      name: "rank_history",
      component: RankHistory
    },
    {
      path: "/rank_history/:user_id/new",
      name: "rank_history_new",
      component: RankHistoryNew
    },
    {
      path: "/rank_history/:rank_history_id/edit",
      name: "rank_history_edit",
      component: RankHistoryEdit
    },
    {
      path: "/accident_history/:user_id",
      name: "accident_history",
      component: AccidentHistory
    },
    {
      path: "/accident_history/:user_id/new",
      name: "accident_history_new",
      component: AccidentHistoryNew
    },
    {
      path: "/accident_history/:accident_history_id/edit",
      name: "accident_history_edit",
      component: AccidentHistoryEdit
    },
    {
      path: "/company_notice",
      name: "company_notice",
      component: CompanyNotice
    },
    {
      path: "/company_notice/new",
      name: "company_notice_new",
      component: CompanyNoticeNew
    },
    {
      path: "/company_notice/:company_notice_id/edit",
      name: "company_notice_edit",
      component: CompanyNoticeEdit
    },
    {
      path: "/master",
      name: "master",
      component: Master
    },
    {
      path: "/master_company",
      name: "master_company",
      component: MasterCompany
    },
    {
      path: "/master_department",
      name: "master_department",
      component: MasterDepartment
    },
    {
      path: "/master_department/new",
      name: "master_department_new",
      component: MasterDepartmentNew
    },
    {
      path: "/master_department/:department_id/edit",
      name: "master_department_edit",
      component: MasterDepartmentEdit
    },
    {
      path: "/master_position",
      name: "master_position",
      component: MasterPosition
    },
    {
      path: "/master_position/new",
      name: "master_position_new",
      component: MasterPositionNew
    },
    {
      path: "/master_position/:position_id/edit",
      name: "master_position_edit",
      component: MasterPositionEdit
    },
    {
      path: "/master_site",
      name: "master_site",
      component: MasterSite
    },
    {
      path: "/master_site/:site_id/detail",
      name: "master_site_detail",
      component: MasterSiteDetail
    },
    {
      path: "/master_site/:site_id/edit",
      name: "master_site_edit",
      component: MasterSiteEdit
    },
    {
      path: "/master_car",
      name: "master_car",
      component: MasterCar
    },
    {
      path: "/master_car/new",
      name: "master_car_new",
      component: MasterCarNew
    },
    {
      path: "/master_car/:car_id/edit",
      name: "master_car_edit",
      component: MasterCarEdit
    },
    {
      path: "/master_phrase",
      name: "master_phrase",
      component: MasterPhrase
    },
    {
      path: "/master_phrase/new",
      name: "master_phrase_new",
      component: MasterPhraseNew
    },
    {
      path: "/master_phrase/:phrase_id/edit",
      name: "master_phrase_edit",
      component: MasterPhraseEdit
    },
    {
      path: "/master_holiday",
      name: "master_holiday",
      component: MasterHoliday
    },
    {
      path: "/master_holiday/new",
      name: "master_holiday_new",
      component: MasterHolidayNew
    },
    {
      path: "/master_holiday/:holiday_id/edit",
      name: "master_holiday_edit",
      component: MasterHolidayEdit
    },
    {
      path: "/master_approval",
      name: "master_approval",
      component: MasterApproval
    },
    {
      path: "/master_approval/:company_id/:department_id/:approval_type",
      name: "master_approval_detail",
      component: MasterApprovalDetail
    },
    {
      path:
        "/master_approval/:company_id/:department_id/:approval_type/:approval_id",
      name: "master_approval_edit",
      component: MasterApprovalEdit
    },
    {
      path: "/attendance",
      name: "attendance",
      component: Attendance
    },
    {
      path: "/attendance/:user_id/user",
      name: "attendance_user_detail",
      component: AttendanceUserDetail
    },
    {
      path: "/attendance/:user_id/user/:date",
      name: "attendance_date_detail",
      component: AttendanceDateDetail
    },
    {
      path: "/attendance/:user_id/user/:date/approval",
      name: "attendance_date_approval",
      component: AttendanceDateApproval
    },
    {
      path: "/approval",
      name: "approval",
      component: Approval
    },
    {
      path: "/notice",
      name: "notice",
      component: Notice
    },
    {
      path: "/csv",
      name: "csv",
      component: Csv
    },
    {
      path: "/csv/attendance",
      name: "csv_attendance",
      component: CsvAttendance
    },
    {
      path: "/csv/site",
      name: "csv_site",
      component: CsvSite
    },
    {
      path: "/csv/cost",
      name: "csv_cost",
      component: CsvCost
    },
    {
      path: "/csv/tkc",
      name: "csv_tkc",
      component: CsvTkc
    }
  ]
};
